import store from "@/store";
const EventBeacon = () => import("./EventBeacon");
const HomeScreen = () => import("./screens/HomeScreen");
const EventScreen = () => import("./screens/EventScreen");
const GameScreen = () => import("./screens/GameScreen");
const NotFound = () => import("./screens/NotFound");
const NoAccess = () => import("./screens/NoAccess");

function iOSVersion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return parseInt(v[1], 10);
    }
}

async function checkAccess(to, from, next) {
    
    if (from.name === 'EventBeacon/Event' && to.name !== 'EventBeacon/Game') {
        store.commit('eventBeacon/setGamePaginationData', {});
    }
    
    if (!store.state.userData.isRetrieved) {
        /**
         * Fetch user's data if it hasn't been accessed yet
         */
        await store.dispatch("userData/retrieveUser");
    }
    if (!store.getters["userData/isCollegeCoach"]) {
        // next({ name: 'EventBeacon/NoAccess', params: { errorType: 'switchAccounts' } })
        // return;
    }

    let iOSver = iOSVersion();
    if (iOSver && iOSver < 11) {
        next({ name: 'EventBeacon/NoAccess', params: { errorType: 'oldiOS' } });
    }
    next();
}

export default {
    path: '/eb_on_demand', component: EventBeacon,
    children: [
        { path: 'events', component: HomeScreen, name: "EventBeacon/Home", beforeEnter: checkAccess, alias: '', props: { tab: 'Events' } },
        { path: 'games', component: HomeScreen, name: "EventBeacon/Games", props: { tab: 'Games' }, beforeEnter: checkAccess },
        { path: 'events/:id/:url', component: EventScreen, name: "EventBeacon/Event", beforeEnter: checkAccess },
        { path: "games/:id", component: GameScreen, name: "EventBeacon/Game", beforeEnter: checkAccess },
        { path: "noaccess", component: NoAccess, name: "EventBeacon/NoAccess", props: true },
        { path: '*', component: NotFound },
    ]
};
